import axios from "axios";
import { baseUrl as url } from "../utils/url";
import getError from "../utils/getError";

export const getData = (path, setData, filter , fullObject) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  let finalFilter = filters.length > 2 ? filters : "";
  axios
    .get(url + `/${path}` + finalFilter)
    .then((res) => {
      if(fullObject){
        setData(res.data);
      }else{
        if (res.data?.result) {
          setData(res.data?.result);
        } else {
          setData(res.data);
        }
      }
    })
    .catch((err) => {
      console.log({
        error: err,
        route: url + `/${path}`,
      });
      setData(null);
    });
};

export const postData = (path, data, afterPerform, originalResponse) => {
  axios
    .post(url + `/${path}`, data)
    .then((res) => {
      let successMsg =
        res.data?.data?.message ||
        res.data?.result?.message ||
        `${path} created successfully`;

      if (originalResponse) {
        if (res.data?.data) {
          afterPerform(res.data?.data, successMsg);
        } else if (res.data?.result) {
          afterPerform(res.data?.result, successMsg);
        }
      } else {
        afterPerform(true, successMsg);
      }
    })
    .catch((err) => {
      console.log(err);
      let errMsg = getError(err) || `Failed to create ${path}`;
      afterPerform(false, errMsg);
    });
};

export const updateData = (path, id, data, afterPerform) => {
  let fullUrl = url + `/${path}/${id}`;

  if (!id) {
    fullUrl = url + `/${path}`;
  }
  axios
    .put(fullUrl, data)
    .then((res) => {
      let successMsg =
        res.data?.data?.message || `${path} updated successfully`;
      afterPerform(true, successMsg);
    })
    .catch((err) => {
      console.log(err);
      let errMsg = getError(err) || `Failed to update ${path}`;
      afterPerform(false, errMsg);
    });
};
export const deleteData = (path, id, afterPerform) => {
  axios
    .delete(url + `/${path}/${id}`)
    .then((res) => {
      let successMsg =
        res.data?.data?.message || `${path} deleted successfully`;
      afterPerform(true, successMsg);
    })
    .catch((err) => {
      console.log(err);
      let errMsg = getError(err) || `Failed to delete ${path}`;
      afterPerform(false, errMsg);
    });
};
